/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = Number.parseInt(this.dataset.cartTotal, 10);
      let currencyRate = Number(window.Shopify?.currency?.rate) || 1;
      let minimum = Math.round(Number.parseFloat(this.dataset.minimum) * currencyRate);
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum && minimum > 0) {
        percentage = Math.max(total, 0) / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
      this.querySelector('.free-shipping--bar')?.setAttribute(
        'aria-valuenow',
        String(Math.round(percentage * 100))
      );
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
